import { Zipcode } from '../../constants/AppConstants';
var FIRST_LETTER_OF_EACH_WORD_REGEX = /^(.)|\s+(.)/g;
var REMAINING_LETTERS_OF_EACH_WORD_REGEX = /(\B)[^ ]*/g;

/**
 * Format string to proper cases
 * will caps first letter and then all lower letters
 * @param string
 * @returns
 */
export function formatProperCase(string) {
  return string ? string.replace(REMAINING_LETTERS_OF_EACH_WORD_REGEX, function (match) {
    return match.toLowerCase();
  }).replace(FIRST_LETTER_OF_EACH_WORD_REGEX, function (match) {
    return match.toUpperCase();
  }) : '';
}

/**
 * Show zipcode if it's valid, null if it's ABCDE (tax requirement for non required zipcode)
 * @param zip zipcode
 * @returns
 */
export var getValidZip = function getValidZip(zip) {
  return zip === Zipcode.ABCDE ? null : zip;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/ReviewMopView/helper.js
// module id = 4576
// module chunks = 11